var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcDarkMode(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "moon-01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M44 31.6885C41.3732 32.8764 38.4573 33.5377 35.3869 33.5377C23.8306 33.5377 14.4623 24.1694 14.4623 12.6131C14.4623 9.54271 15.1236 6.62679 16.3115 4C9.05152 7.28326 4 14.5894 4 23.0754C4 34.6317 13.3683 44 24.9246 44C33.4106 44 40.7167 38.9485 44 31.6885Z",
    stroke: "#000A66",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 9",
    opacity: 0.3,
    cx: 39,
    cy: 8,
    r: 4,
    fill: "#000A66"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDarkMode);
export default __webpack_public_path__ + "static/media/ic-dark-mode.228bc3111d41d04655e20225d8cdabc3.svg";
export { ForwardRef as ReactComponent };